var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 2.6665V8.6665C11.8333 9.3865 11.42 10.0065 10.82 10.3065C10.8266 10.2065 10.8333 10.1065 10.8333 9.99984V3.99984C10.8333 2.43984 9.55996 1.1665 7.99996 1.1665H2.41996C2.72663 0.573171 3.33996 0.166504 4.05329 0.166504H9.33329C10.7133 0.166504 11.8333 1.2865 11.8333 2.6665ZM7.99996 2.1665H1.99996C0.988626 2.1665 0.166626 2.9885 0.166626 3.99984V9.99984C0.166626 11.0112 0.988626 11.8332 1.99996 11.8332H7.99996C9.01129 11.8332 9.83329 11.0112 9.83329 9.99984V3.99984C9.83329 2.9885 9.01129 2.1665 7.99996 2.1665Z",
    fill: "#9027E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkCopy);
export default __webpack_public_path__ + "static/media/pink-copy.38f7945662d57f05bd4e1d393f0b7e64.svg";
export { ForwardRef as ReactComponent };